/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';
import { AuthService } from './services/AuthService';
import { BillingCodesService } from './services/BillingCodesService';
import { CallbacksService } from './services/CallbacksService';
import { DictationService } from './services/DictationService';
import { DoctorSpecialitiesService } from './services/DoctorSpecialitiesService';
import { PatientSessionsService } from './services/PatientSessionsService';
import { PreferencesService } from './services/PreferencesService';
import { PromptTemplatesService } from './services/PromptTemplatesService';
import { SessionFormatsService } from './services/SessionFormatsService';
import { TardocDoctorSpecialitiesService } from './services/TardocDoctorSpecialitiesService';
import { UploadService } from './services/UploadService';
import { UserService } from './services/UserService';
import { VocabularyTermsService } from './services/VocabularyTermsService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ApiClient {
    public readonly auth: AuthService;
    public readonly billingCodes: BillingCodesService;
    public readonly callbacks: CallbacksService;
    public readonly dictation: DictationService;
    public readonly doctorSpecialities: DoctorSpecialitiesService;
    public readonly patientSessions: PatientSessionsService;
    public readonly preferences: PreferencesService;
    public readonly promptTemplates: PromptTemplatesService;
    public readonly sessionFormats: SessionFormatsService;
    public readonly tardocDoctorSpecialities: TardocDoctorSpecialitiesService;
    public readonly upload: UploadService;
    public readonly user: UserService;
    public readonly vocabularyTerms: VocabularyTermsService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.auth = new AuthService(this.request);
        this.billingCodes = new BillingCodesService(this.request);
        this.callbacks = new CallbacksService(this.request);
        this.dictation = new DictationService(this.request);
        this.doctorSpecialities = new DoctorSpecialitiesService(this.request);
        this.patientSessions = new PatientSessionsService(this.request);
        this.preferences = new PreferencesService(this.request);
        this.promptTemplates = new PromptTemplatesService(this.request);
        this.sessionFormats = new SessionFormatsService(this.request);
        this.tardocDoctorSpecialities = new TardocDoctorSpecialitiesService(this.request);
        this.upload = new UploadService(this.request);
        this.user = new UserService(this.request);
        this.vocabularyTerms = new VocabularyTermsService(this.request);
    }
}

